import { Button } from './bootstrap';

( function( $ ) {
    /**
     * 
     * @param {*} event 
     * @returns 
     */
    function handleProjectSliderClick(event) {
        const card = self;
        const cardHolder = self.parent;
        var targetOffset = card.offsetLeft - cardHolder.childNodes[1].offsetLeft
        var currentOffset = cardHolder.scrollLeft;
        //var current = parseInt(cardHolder.scrollLeft / $('.card').width());
        $('.cards-navigation').find('.card-dot').each(function() {
          $(this).removeClass('active');
        });
        $('.cards-navigation').find('.card-dot').eq(current).addClass('active');
      
        var rect = card.getBoundingClientRect()
      
        if (0 <= rect.left && rect.right <= (window.innerWidth || document.documentElement.clientWidth)) {
          return true
        }
    
      
        cardHolder.scrollTo({
          top: 0,
          left: targetOffset,
          behavior: "smooth"
        })
      
        return false
    };

    const cards = document.querySelectorAll('.project-slider > figure.wp-block-embed');
    cards.forEach(card => {
        //card.addEventListener
    });

    /**
     * Handle Project filtering based on category.
     */
    const toggleProject = (_ev) => {
      // Labels of the checkboxes
      const $boxes = $('.project-type-filtering li label');
      // Names of unchecked boxes
      const unchecked = $boxes.filter((_idx, el) => $(el).find('input[type="checkbox"]').not(':checked').length)
                              .map((idx, el) => $(el).find('span.project-filter-text').text().trim())
                              .toArray();
      const checked = $boxes.filter((_idx, el) => $(el).find('input[type="checkbox"]:checked').length)
                            .map((_idx, el) => $(el).find('span.project-filter-text').text().trim())
                            .toArray();
      // Project tiles to be filtered
      const $listItems = $(' .project-list-item');

      // Unconditionally show all list items, so they can take their place in the grid.
      $listItems.show();

      // If no checkbox is checked, show the easteregg iframe.
      if (unchecked.length === $boxes.length) {
        $('.easteregg').removeClass('invisible');
      }
      else {
        $('.easteregg').addClass('invisible');
      }
      // Now, update the visibility of all tiles.
      $listItems.each((idx, el) => {
        // Extract the project types of the list item.
        const names = [...el.classList.values()]
          .filter(cls => cls.indexOf('projecttype-') >= 0)
          .map(cls => cls.replace('projecttype-', ''));

        // Check if at least one project type is checked.
        if (names.some(pt => checked.includes(pt))) {
          $(el).removeClass('inactive');
        }
        else {
          $(el).addClass('inactive');
          // After a short delay, remove this item from render flow to avoid gaps in the grid.
          setTimeout(() => $(el).hide(), 400);
        }
      });
      
    };

    $(document).ready( function() {
      $('.project-type-filtering li label input').each(function() { $(this).on('change', toggleProject) });
    });
    
})( jQuery );
